import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { MFAVerify as MFAVerifyComponent } from '@gtintel/signin/components/auth/MFAVerify';
import { AuthLayout } from '@gtintel/signin/components/layout/AuthLayout';

interface LocationState {
  temporaryToken: string;
  mfaMethods: ('totp' | 'sms')[];
  redirectUrl: string;
  sourceUrl?: string;
  rememberMe: boolean;
}

export const MFAVerify: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as LocationState;

  useEffect(() => {
    // If no state, redirect to login
    if (!state?.mfaMethods) {
      navigate('/login');
    }
  }, [state, navigate]);

  if (!state?.mfaMethods) {
    return null;
  }

  return (
    <AuthLayout title="Verify Identity">
      <MFAVerifyComponent
        temporaryToken={state.temporaryToken}
        availableMethods={state.mfaMethods}
        redirectUrl={state.redirectUrl}
        sourceUrl={state.sourceUrl}
        rememberMe={state.rememberMe}
      />
    </AuthLayout>
  );
};
